module.exports = __webpack_public_path__ + "static/media/login-practice.a2839b3a.jpg";